(function () {
  function readConfig(section) {
    const configNode = section.querySelector("[data-zeppy-config]");

    if (!configNode) {
      return {};
    }

    try {
      return JSON.parse(configNode.textContent);
    } catch (error) {
      return {};
    }
  }

  function initZeppyShop(section) {
    if (!section || section.dataset.zeppyInitialized === "true") {
      return;
    }

    const slots = Array.from(section.querySelectorAll("[data-zeppy-item]"));
    const zeppyButton = section.querySelector("[data-zeppy-talk]");
    const dialogueTitle = section.querySelector("[data-zeppy-dialogue-title]");
    const dialogueText = section.querySelector("[data-zeppy-dialogue-text]");
    const dialogueControls = section.querySelector("[data-zeppy-controls]");
    const previousButton = section.querySelector("[data-zeppy-previous]");
    const nextButton = section.querySelector("[data-zeppy-next]");
    const viewButton = section.querySelector("[data-zeppy-view]");
    const zeppyImage = section.querySelector("[data-zeppy-image]");
    const config = readConfig(section);
    const phrases = (config.phrases || []).filter((phrase) => phrase && phrase.text);
    const images = config.images || {};
    let activeIndex = -1;
    let zeppyPhraseIndex = phrases.length > 1 ? 1 : 0;

    section.dataset.zeppyInitialized = "true";

    function clearActiveItem() {
      slots.forEach((slot) => {
        slot.dataset.active = "false";
        slot.setAttribute("aria-pressed", "false");
      });
    }

    function setViewState(slot) {
      const isAvailable = slot.dataset.available === "true";
      const url = slot.dataset.url || "#";

      viewButton.textContent = isAvailable ? config.viewText || "View" : config.comingSoonText || "Coming soon";
      viewButton.setAttribute("aria-disabled", String(!isAvailable));
      viewButton.href = isAvailable ? url : "#";
      viewButton.tabIndex = isAvailable ? 0 : -1;
    }

    function setActive(index) {
      if (!slots.length) {
        return;
      }

      activeIndex = (index + slots.length) % slots.length;
      const activeSlot = slots[activeIndex];

      slots.forEach((slot, slotIndex) => {
        const isActive = slotIndex === activeIndex;
        slot.dataset.active = String(isActive);
        slot.setAttribute("aria-pressed", String(isActive));
      });

      dialogueTitle.textContent = activeSlot.dataset.name || "";
      dialogueText.textContent = activeSlot.dataset.text || activeSlot.dataset.name || "";
      dialogueControls.hidden = false;
      setViewState(activeSlot);

      if (zeppyImage && images.standard) {
        zeppyImage.src = images.standard;
      }
    }

    slots.forEach((slot, index) => {
      slot.addEventListener("click", () => setActive(index));
    });

    if (previousButton) {
      previousButton.addEventListener("click", () => setActive(activeIndex >= 0 ? activeIndex - 1 : slots.length - 1));
    }

    if (nextButton) {
      nextButton.addEventListener("click", () => setActive(activeIndex >= 0 ? activeIndex + 1 : 0));
    }

    if (viewButton) {
      viewButton.addEventListener("click", (event) => {
        if (viewButton.getAttribute("aria-disabled") === "true") {
          event.preventDefault();
        }
      });
    }

    if (zeppyButton) {
      zeppyButton.addEventListener("click", () => {
        const phrase = phrases[zeppyPhraseIndex] || phrases[0];

        if (!phrase) {
          return;
        }

        clearActiveItem();
        activeIndex = -1;
        dialogueTitle.textContent = config.defaultTitle || "Zeppy";
        dialogueText.textContent = phrase.text;
        dialogueControls.hidden = true;

        if (zeppyImage && images[phrase.emotion]) {
          zeppyImage.src = images[phrase.emotion];
        }

        zeppyPhraseIndex = (zeppyPhraseIndex + 1) % phrases.length;
      });
    }
  }

  function initAllZeppyShops(root) {
    const scope = root || document;
    scope.querySelectorAll("[data-windborne-game-shop]").forEach(initZeppyShop);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAllZeppyShops(document));
  } else {
    initAllZeppyShops(document);
  }

  document.addEventListener("shopify:section:load", (event) => {
    initAllZeppyShops(event.target);
  });
})();
